import { render, staticRenderFns } from "./CarCategoryModal.vue?vue&type=template&id=56a84276&scoped=true&"
import script from "./CarCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CarCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a84276",
  null
  
)

export default component.exports